import { getSettingsGenericError } from './chunk-TDNRUBPG.mjs';
import { i18n_config_default } from './chunk-EJ2TIXJU.mjs';
import * as yup from 'yup';

var rolesSchema = yup.object().shape({
  name: yup.string().trim().required(
    JSON.stringify(
      getSettingsGenericError({
        key: "name",
        id: "name",
        message: i18n_config_default.t("validations.nameRequired"),
        section: "basic" /* BASIC */
      })
    )
  ),
  posName: yup.string().trim().required(
    JSON.stringify(
      getSettingsGenericError({
        key: "posName",
        id: "posName",
        message: i18n_config_default.t("validations.posNameRequired"),
        section: "basic" /* BASIC */
      })
    )
  )
});

export { rolesSchema };
